module.exports = __webpack_public_path__ + "img/JDBa.afa7b0bc.png";